module.exports = __webpack_public_path__ + "static/media/network_check_violet.5fa5c379.svg";